class DrawerPromoCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousel()
  }

  setupCarousel () {
    if (this.els.slides == null || this.els.slides.exists == false) return
    if (this.els.slide == null || this.els.slide.exists == false) return

    this.keenSliderInstance = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        rubberband: false,
        mode: 'snap',
        slides: {
          perView: 1.75,
          spacing: 10,
        },
      },
      [window.BAO.Carousel.plugins.useInitialised()],
    )
  }
}

if (!customElements.get('drawer-promo-carousel')) {
  customElements.define('drawer-promo-carousel', DrawerPromoCarousel)
}
